import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgDreadnoughtClassBallisticSubmarine = function ({
  size = 16,
  ...props
}: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 30"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="m52.735.699-.006.005zl.243-.206.082-.067c.33-.258.655-.405 1.055-.425L54.208 0h16.69c1.028 0 1.716.222 1.924.728a.1.1 0 0 1 .006.038l.304 1.251 1.413 5.695h65.505c9.301 0 33.327 3.123 40.548 5.094l.682.188.533.149 1.532-3.27.088-.18.014-.025c.156-.244.647-.324 1.693-.343l.224-.003h.233l.39-.001q.263 0 .56.02c.349.023.721.064 1.101.118q.237.035.454.071l.14.024.233.044a.08.08 0 0 1 .064.062l.003.02v4.833l-.006.022.006 1.097 4.75 1.903-.007-1.71 4.71 1.115v2.396q1.912.69 1.912.935c0 .247-1.351.951-1.911 1.118v2.482l-4.704 1.12-.007-1.714a611 611 0 0 0-4.75 1.683q-.23.09-.078 3.928-4.437.25-4.815.077-.377-.173-1.597-2.263a105.6 105.6 0 0 1-22.888 2.556h-.497q-13.048.019-112.513-.003l-18.025-.075q-3.482.03-9.79-1.122C12.025 26.906 3.6 25.03 2.85 24.56S.137 20.766.09 20.513s.674-2.406 1.175-3.334c.323-.598.957-1.781 1.818-2.6a.08.08 0 0 1 .022-.07q.077-.078.164-.154l.08-.067a.08.08 0 0 1 .02-.103c.527-.428 1.392-.845 2.761-1.326l.47-.165 1.66-.593c.459-.162.911-.32 1.23-.426l.084-.028a53 53 0 0 1 5.35-1.437 91 91 0 0 1 7.084-1.22l.515-.069c2.349-.295 8.61-.744 16.082-1.076q1.065-.054 2.102-.087l.796-.022c.291-.008.615-.02.964-.039a37 37 0 0 0 2.926-.257c1.86-.245 3.213-.617 3.832-1.128a.1.1 0 0 1 .046-.02l.755-1.215L52.72.717l.005-.007z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgDreadnoughtClassBallisticSubmarine
